<template>
    <main class="dynamic-page">
        <client-only>
            <div class="sr-only">
                hydration: true
            </div>
        </client-only>

        <StructureSection
            v-for="(section, index) in page?.structure"
            :key="section.id"
            :count="index"
            :content="section"
        />
    </main>
</template>

<script setup lang="ts">
import { usePage, showError, useRoute, useAsyncData, useHead, useSeoMeta } from '#imports'
import { normalizeSlashes } from '@/utils/helper'

useRouteCache((helper) => {
    helper.setMaxAge(60).setCacheable()
})

/*
 * Page request and error handling
 */
const route = useRoute();

const { page, getPage } = usePage();

const { data, error } = await useAsyncData('indexPage', () => getPage(route));

page.value = data.value

if (error.value) {
    showError(error.value as Error)
}

const config = useRuntimeConfig().public

let canonicalUrl = config?.appBaseUrl + page.value?.canonicalUrl

canonicalUrl = normalizeSlashes(canonicalUrl)

const ogTitle = page?.value?.category?.metaTitle ?? page?.value?.category?.name
const ogImage = page?.value?.category?.media?.url

useSeoMeta({
    description: page?.value?.category?.metaDescription,
    ogType: 'website',
    ogSiteName: ogTitle,
    ogTitle,
    ogDescription: page?.value?.category?.metaDescription,
    ogUrl: canonicalUrl,
    ogImage,
    ogImageAlt: ogTitle
})

useHead({
    title: ogTitle,
    link: [
        {
            rel: 'canonical',
            href: canonicalUrl
        }
    ]
})
</script>
